import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  CreateOdPayload,
  CreateOutdoorDutyResponse,
  GetOutdoorDutyResponseById,
  OutdoorDutyParams,
  OutdoorDutyResponse,
  UpdateStatusPayload,
} from "@/interface/od.interface";

export const OdService = {
  getList: async (params?: OutdoorDutyParams): Promise<OutdoorDutyResponse> => {
    const query = new URLSearchParams();
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          query.append(key, String(value));
        }
      });
    }
    const url = `${API_ENDPOINT.od}?${query.toString()}`;
    return callApi<OutdoorDutyResponse>(url, { method: "GET" });
  },

  create: async (
    payload: CreateOdPayload,
  ): Promise<CreateOutdoorDutyResponse> => {
    return callApi<CreateOutdoorDutyResponse>(API_ENDPOINT.od, {
      method: "POST",
      data: payload,
    });
  },

  delete: async (id: string): Promise<GetOutdoorDutyResponseById> => {
    const url = `${API_ENDPOINT.od}/${id}`;
    return callApi<GetOutdoorDutyResponseById>(url, { method: "DELETE" });
  },

  getById: async (id: string): Promise<GetOutdoorDutyResponseById> => {
    const url = `${API_ENDPOINT.od}/${id}`;
    return callApi<GetOutdoorDutyResponseById>(url, { method: "GET" });
  },

  updateStatus: async (
    id: string,
    payload: UpdateStatusPayload,
  ): Promise<GetOutdoorDutyResponseById> => {
    const url = `${API_ENDPOINT.od}/${id}/status`;
    return callApi<GetOutdoorDutyResponseById>(url, {
      method: "PUT",
      data: payload,
    });
  },
};
